import { $generateHtmlFromNodes, RichTextEditor } from '@talentmesh/rte';
import { TypographyP } from '@talentmesh/ui/components/typography';
import { useState } from 'react';
import { useController } from 'react-hook-form';
import { useCompanyProfileFormContext } from '../useCompanyProfileForm';
import ProfileGroupForm from './ProfileGroupForm';
import UIStrings from '@/Utils/UIStrings';

function CompanyDescriptionSection() {
    const { formState, control, setValue } = useCompanyProfileFormContext();
    const { fieldState } = useController({ control, name: 'companyDescription' });
    const errMsg = fieldState.error?.message;
    const [isInitialRender, setIsInitialRender] = useState(true);

    return (
        <ProfileGroupForm
            dataCy="CompanyDescriptionSection"
            title={`${UIStrings.CompanyDescription}*`}
            description={UIStrings.CompanyDescriptionExplanation}
            width="100%"
        >
            <div className="flex w-full flex-col">
                <RichTextEditor
                    data-cy="CompanyDescription"
                    initialHtml={formState.defaultValues?.companyDescription}
                    features={['headingStyle', 'bold', 'italic', 'ol', 'ul']}
                    onChange={(editorState, editor) => {
                        editorState.read(() => {
                            setValue('companyDescription', $generateHtmlFromNodes(editor), {
                                shouldValidate: !isInitialRender,
                            });

                            if (isInitialRender) {
                                setIsInitialRender(false);
                            }
                        });
                    }}
                    contentEditableProps={{
                        className: `flex-1 max-h-60 ${errMsg ? 'border border-destructive' : ''}`,
                    }}
                />
                {errMsg && <TypographyP className="text-destructive mt-1">{errMsg}</TypographyP>}
            </div>
        </ProfileGroupForm>
    );
}

export default CompanyDescriptionSection;
